import { Injectable, inject } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {BehaviorSubject, Observable} from 'rxjs';
import {Contato} from '../model/contato/contato.model';
import { ContatosChatResposta } from '../model/chat/contatos-chat-resposta.model';
import { FiltroChatContatos } from '../model/contato/filtro-chat-contatos.model';
import { ContatoSessaoBusca } from '../model/contato/contato-sessao.model';
import { IdNome } from '../model/id-nome.model';
import {ContatoCadastro} from '../model/contato/contato-cadastro.model';
import {NomeMidiaInfosFechamento} from '../model/chat/nome-midia-infos-fechamento.model';

@Injectable({
  providedIn: 'root'
})
export class ContatoService {

  private readonly http = inject(HttpClient);

  urlBase = `${environment.urlBase}/contato`;

  private contatoSelecionadoSubject = new BehaviorSubject<Contato | null>(null);
  contatoSelecionado$ = this.contatoSelecionadoSubject.asObservable();

  buscarContatos(noLoading?: boolean, filtroNomeContato?: IdNome, page = 0, size = 20): Observable<Contato[]> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('pageSize', size.toString());
    return this.http.post<Contato[]>(`${this.urlBase}/buscar-tela`,
      filtroNomeContato,
      { headers: { 'no-loading': noLoading ? 'true' : 'false' }, params });
  }

  buscarContatoPorId(contatoId: number): Observable<Contato> {
    return this.http.get<Contato>(`${this.urlBase}/buscar-contato-completo/${contatoId}`);
  }

  buscarContatoPorTelefone(telefone: string, noLoading = false): Observable<Contato> {
    const headers = new HttpHeaders({ 'no-loading': `${noLoading}` });
    return this.http.get<Contato>(
      `${this.urlBase}/telefone/${telefone}`,
      { headers }
    );
  }

  buscarContatosChat(filtro: FiltroChatContatos, page: number, pageSize = 25, contar = true): Observable<ContatosChatResposta> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('pageSize', pageSize.toString())
      .set('contar', String(contar));
    return this.http.post<ContatosChatResposta>(`${this.urlBase}/chat/buscar`, filtro, {
      params,
      headers: new HttpHeaders({ 'no-loading': 'true' })
    });
  }

  buscarContatosTelaContatos(filtro: FiltroChatContatos, page: number, pageSize = 25, contar = true): Observable<ContatosChatResposta> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('pageSize', pageSize.toString())
      .set('contar', String(contar));
    return this.http.post<ContatosChatResposta>(`${this.urlBase}/tela/buscar`, filtro, {
      params,
      headers: new HttpHeaders({ 'no-loading': 'true' })
    });
  }

  alterarFavorito(contatoId: number, favorito: boolean): Observable<boolean> {
    return this.http.put<boolean>(`${this.urlBase}/favorito/${contatoId}`, null, {
      params: new HttpParams().set('favorito', String(favorito)),
      headers: new HttpHeaders({ 'no-loading': 'true' })
    });
  }

  selecionarContato(contato: Contato) {
    this.contatoSelecionadoSubject.next(contato);
  }

  limparContato() {
    this.contatoSelecionadoSubject.next(null);
  }

  salvarMsgLida(contatoId: number): Observable<boolean> {
    return this.http.put<boolean>(`${this.urlBase}/salvar-msg-lida`, contatoId);
  }

  visualizarContato(contato: Contato): Observable<any> {
    return this.http.put(`${this.urlBase}/visualizar-contato`, contato);
  }

  buscarInfoBasicasContatoAndSessao(contatoId: number): Observable<ContatoSessaoBusca>{
    return this.http.get<ContatoSessaoBusca>(`${this.urlBase}/info-basicas-contato-e-sessao/${contatoId}`);
  }

  salvarContato(contato: ContatoCadastro): Observable<number> {
    return this.http.post<number>(`${this.urlBase}`, contato);
  }

  editarNomeContato(contatoInfo: NomeMidiaInfosFechamento): Observable<NomeMidiaInfosFechamento> {
    return this.http.put<NomeMidiaInfosFechamento>(`${this.urlBase}/nome`, contatoInfo);
  }

  verificarUsuarioIsCoordenadorCanalContatoId(contatoId: number): Observable<number>{
    return this.http.get<number>(`${this.urlBase}/usuario-is-coordenador-canal-contatoId/${contatoId}`);
  }

}
